export class ICartModal {
    constructor(message, relatedEvents, date) {
        this.message = message;
        this.relatedEvents = relatedEvents;
        this.date = date;
    }
}
